/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import jwt_decode from "jwt-decode";
import ApproveRejectPopUp from "../ApproveRejectPopUp/ApproveRejectPopUp.vue";
import customModal from "../customModal/customModal.vue";
import ApprovalStatusPopUp from "../ApprovalStatusPopUp/ApprovalStatusPopUp.vue"
import QcReviewPopup from "./QcReviewPopup.vue"
export default {
  components: {
    ApproveRejectPopUp,
    customModal,
    ApprovalStatusPopUp,
    QcReviewPopup,
    VPagination,

  },
  data() {
    return {
      fileName: "",
      showstatuspop: false,
      getbyId: "",
      fileName: "",
      docId: "",
      versionNo: "",
      showpop: false,
      idtoken: "",
      showDesig: false,
      showLoading:true,
      comments: "",
      userList: "",
      retrievebox: true,
      designationId: "",
      currentPage: 1,
      pageindex: 1,
      pagesize: 10,
      totalPage: 1,
      SortProperty: "assignedDateTime",
      SortOrder: false,
      SortOrderInt: 1,
      errors: [],
      validations: [],
      disignations: {},
      update: {
        designationId: "",
        name: "",
        description: "",
        active: true,
      },
      values: {
        name: "",
        description: "",
        active: true,
      },
      approvalList: [],
      
      
      baseurl: process.env.VUE_APP_Service_URL,
      baseapi: process.env.VUE_APP_Service_URL,
      currentPage: 1,
      pageindex: 1,
      pagesize: 10,
      totalPage: 1,
      SortProperty: "assignedDateTime",
      SortOrder: false,
      SortOrderInt: 1,
      searchField: {
        documentTitle: "",
        createdAt: "",
        status: ""
      },
      designationPrivileges: "",
      showCollapse: [false],
      getStudyId: "",
      showReviewPopup: false,
      reviewComments: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    const previousRouteName = from.name;
    console.log("previousRouteName", previousRouteName);
    if (previousRouteName == 'etmfdoc') {
      localStorage.setItem("setDocViewSource", "Approval")
    }
    if (previousRouteName == 'etmf' && localStorage.getItem("presentPage") != null) {
      localStorage.setItem("presentPage", "etmf")
    }
    if (previousRouteName == 'etmf' || previousRouteName == "signerslist") {
      localStorage.setItem("presentPage", "etmf")
    }
 
    if (previousRouteName == 'etmf') {
      localStorage.setItem("presentPage", "etmf")
    }
    if (previousRouteName == 'folderDocLogin') {
      localStorage.setItem("presentPage", "folderDocLogin")
    }
    if (previousRouteName == 'etmfdoc') {
      localStorage.setItem("presentPage", "etmfdoc")
    }
    if (previousRouteName == 'folder') {
      localStorage.setItem("presentPage", "folder")
    }
    if(previousRouteName == 'TmfDocReviewList'){
      localStorage.setItem("presentPage", "TmfDocReviewList")
    }
    next((vm) => {
      vm.previousRouteName = previousRouteName;
    });
  },
  async mounted() {
    this.designationPrivileges = store.getters.getRolesprivilegeData.split(',');
    window.addEventListener("ApprovalStatusChange", (event) => {
      if (event.detail && event.detail.storage === true) {
        console.log("ApprovalStatusChange == " + event.detail.storage);
       
        this.showpop = false;
        this.RefreshedDocApprovalList();
      }
    });
    this.Head = {
      headers: {
        Authorization: "Bearer " + store.getters.getToken,
        "Content-Type": "application/json",
      },
    };
    this.idtoken = store.getters.getToken;
    window.addEventListener("studyIdChanged", (event) => {
      this.getStudyId = store.getters.getStudyIs
      console.log(this.getStudyId, "getStudyId in DocApprovalList");
      this.DocApprovalList();
    }
    );
    this.DocApprovalList();
  },
  methods: {

    async DocApprovalList() {
      this.showpop = false;

      const idtoken = store.getters.getIdToken;
      this.showLoading=true
      await axios
        .get(
          `${this.baseurl}/etmf/document/getapprovallist?PageIndex=${this.pageindex}&PageSize=${this.pagesize}&title=${this.searchField.documentTitle}&uploadeddate=${this.searchField.createdAt}&status=${this.searchField.status}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrderInt}&StudyId=${store.getters.getStudyIs}&actionType=qc`,
          //`https://localhost:5001/document/getapprovallist?PageIndex=${this.pageindex}&PageSize=${this.pagesize}&title=${this.searchField.documentTitle}&uploadeddate=${this.searchField.createdAt}&status=${this.searchField.status}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrderInt}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.approvalList = res.data.entities;

          // console.log("list approval", this.approvalList);
          this.totalPage = parseInt(res.data.totalCount / this.pagesize);
          if (res.data.totalCount % this.pagesize != 0) {
            this.totalPage = this.totalPage + 1;
          }
           this.showLoading=false

        })
        .catch((err) => {

           this.showLoading=false
          this.userList = []
          alert("No data found!")

        })

    },
    async ApproveReject(docId, versionNo) {
        this.showReviewPopup = true,
        this.docId = docId,
        this.versionNo = versionNo
    },
    showCollapseFunc(index) {
      this.showCollapse[index] = !this.showCollapse[index];
    },
    async ApproveStatus(documentTitle, docId, versionNo) {
      console.log("Inside ApproveStatus popup")
      this.showstatuspop = true,
        this.getApprovalStatus(documentTitle, docId, versionNo);
      this.fileName = documentTitle,
        this.docId = docId,
        this.versionNo = versionNo
    },
    async getApprovalStatus(documentTitle, docId, versionNo) {
      this.idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/approvalstatus?documentId=${docId}&version=${versionNo}&actionType=qc`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.getbyId = res.data;
          console.log("getBYId", this.getbyId);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async approvalScreen(id, name, version) {
     
      await store.dispatch("setFromPage","Approval")
      console.log("approvalScreen called", id, name, version);
      this.$router.push(`/documentview/${id}/${version}`)
      
    },
    async viewDocument(id, name, version) {
      this.$router.push(`/documentview/${id}/${version}`)
    },
    async RefreshedDocApprovalList() {
      console.log("DAS", this.searchField);
      console.log("page number is ", this.pageindex);
      await axios
        .get(
          `${this.baseurl}/etmf/document/getapprovallist?PageIndex=${this.pageindex}&PageSize=${this.pagesize}&title=${this.searchField.documentTitle}&uploadeddate=${this.searchField.createdAt}&status=${this.searchField.status}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrderInt}&actionType=qc`,

          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.approvalList = res.data.entities;
          this.totalPage = parseInt(res.data.totalCount / this.pagesize);
          if (res.data.totalCount % this.pagesize != 0) {
            this.totalPage = this.totalPage + 1;
          }
        })
        .catch((err) => {
          console.log(err);
          this.userList = []
          alert("No data found!")
        })
    },

    async OnSearchButtonClicked() {
      console.log("Search button clicked");
      this.pageindex = 1;
      this.currentPage = 1;
      this.DocApprovalList()
    },
    SortSelected(sortProp) {
      if (this.SortProperty === sortProp) {
        // Same column clicked → toggle sort direction
        this.SortOrder = !this.SortOrder;
      } else {
        // New column clicked → reset to ascending
        this.SortProperty = sortProp;
        this.SortOrder = true;
      }

      this.SortOrderInt = this.SortOrder ? 0 : 1;
      this.pageindex = 1;
      this.currentPage = 1;

      this.DocApprovalList();
    },

    async ApprovalStatus(value) {
      if (value == true) {
        this.status = "Approved";
      } else {
        this.status = "Rejected";
      }
      if (value == true) {
        if (confirm("Are you sure you want to approve the document?")) {
          await this.approvalsave(value);
        }
      } else {
        if (confirm("Are you sure you want to reject the document?")) {
          await this.approvalsave(value);
        }
      }
    },

    async approvalsave(value) {
      const idtoken = store.getters.getIdToken;
      try {
      await axios.put(
        `${this.baseurl}/etmf/document/approvereject`,
        {
        documentId: this.docId,
        version: this.versionNo,
        approvalStatus: this.status,
        comments: this.comments,
        },
        {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
        }
      );
      if (value == true) {
        alert("Document approved successfully.");
      } else {
        alert("Document rejected successfully.");
      }
      this.DocApprovalList();
      this.comments = "";
      this.close();
     
      this.showpop = false;
      
      } catch (err) {
      console.log(err);
      }
    },
    close() {
      this.showpop = false;
      this.comments = "";
      this.$emit("closemodal"); 
    },
    loadPage: function (page) {
      this.currentPage = page;
      this.pageindex = page;
      this.DocApprovalList();
    },
     async onQcReviewSaved({ approved, status, comments }) {
      await this.DocApprovalList();
    },
  },
};


